
const images = {
  wechat_tips: "wechat_tips.png",
  lkby: {
    wechat_tips: "wechat_tips.png",
    tg: {
      header: "lkby/tg-index-top.png",
      level_vip: "lkby/tg-user-vip.png",
      level_def: "lkby/tg-user-def.png",
      bind_bg: "lkby/tg-bind-bg.png",
      no_user: "lkby/tg-no-user.png",
      ext_top: "lkby/tg-rows-top-ext.png",
      exd_top: "lkby/tg-rows-top-exd.png",
      btn_ex: "lkby/tg-btn-extend.png",
      btn_dw: "lkby/tg-btn-down.png",
      btn_no: "lkby/tg-btn-cancel.png",
      btn_ok: "lkby/tg-btn-confirm.png",
      num: "lkby/num/"
    },
    down: {
      btn1: "lkby/down-btn.png",
      btn_bg: "lkby/down-btn-bg.png",
      header: "lkby/down-header.png",
      imgs_top: "lkby/down-imgs-top.png",
      imgs_bg: "lkby/down-imgs-bg.png",
      imgs_end: "lkby/down-imgs-end.png",
      rp_list_top: "lkby/down-rp-list-top.png",
      rp_list_bg: "lkby/down-rp-list-bg.png",
      rp_list_end: "lkby/down-rp-list-end.png",
      ios_tip: "lkby/down-ios-tips.png",
      imgs: {
        item1: "lkby/img1.png",
        item2: "lkby/img2.png",
        item3: "lkby/img3.png",
        item4: "lkby/img4.png"
      }
    },
    scan: {
      pc_top: "lkby/scan-pc-top.png",
      pc_bg: "lkby/scan-pc.png",
      app_bg: "lkby/scan-app.png"
    }
  }
};

export default images;


// WEBPACK FOOTER //
// ./src/assets/js/imageph.js